const getters = {
    customers: (state) => state.customers,
    custId: (state) => state.custId,
    order: (state) => state.order,
    quotation: (state) => state.quotation,
    invoice: (state) => state.invoice,
    details: (state) => state.details,
    profiledetails: (state) => state.profiledetails,
    contacts: (state) => state.contacts,
    opportunity: (state) => state.opportunity,
    complaint: (state) => state.complaint,
    loading: state => state.loading
};

export default getters;